import { useContext, useEffect } from "react"
import { useParams } from 'react-router-dom'
import { useFormikContext } from "formik"
import { FormContext } from "../../../context/formContext"

import styles from "../../../styles/Form.module.css"

export default function IdEnterprise({ field, block, index }) {
  const formik = useFormikContext()
  const form = useContext(FormContext)

  const { type } = useParams()
  const isEnterprise = type === 'enterprise'

  useEffect(() => {
    // Register field as loading in FormContext
    form && form.registerLoadingField(field)

    formik.setFieldValue(field.field_name, isEnterprise)

    // Notify FormContext that field is loaded
    form && form.completeLoadingField(field)

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className={styles.hidden} style={{ order: index }}>
      <input
        type="hidden"
        name={field.field_name}
        value={formik.values[field.field_name]}
      />
    </div>
  )
}
